import * as marietta from '../..';
import { CONTROL_ACTIONMODE, ITEM_MODE_KEY } from '../Constants';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';
import * as THREE from 'three';

export default class GroupItem {
    myItemList: marietta.webcad.item.MonicaObject[];

    localDragPoint: marietta.core.Point;

    previousPlace: marietta.core.Point;

    shapeList: string[] = [];

    hasGridSnapItem: boolean = false;

    isFollowingMouse: boolean;

    private dragInitX: number;

    private dragInitY: number;

    public spt: SVGSprite;

    private moveMouseEvent: MouseEvent;

    /**
     * コンストラクタ
     * @param リスト
     */
    constructor(itemList: marietta.webcad.item.MonicaObject[]) {
      this.isFollowingMouse = false;

      this.myItemList = itemList;

      // イメージの作成
      this.createImage();

      // 初期化
      this.initMe();
    }

    /**
     * ビューの作成
     */
    createImage() {
      let i: number;
      let elementName: string;

      // 初期化
      for (i = 0; i < this.shapeList.length; i += 1) {
        elementName = this.shapeList[i];
        document.querySelector(`#${elementName}`).remove();
      }
      this.shapeList = [];
      this.hasGridSnapItem = false;

      let rects: SVGElement;
      if (this.spt === null || this.spt === undefined) {
        const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        viewObj.setAttribute('id', 'groupDummyBox');
        this.spt = new SVGSprite(viewObj);
      }
      this.spt.x = 0;
      this.spt.y = 0;
      this.spt.update();

      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      let bound: any;
      let TL: marietta.core.Point;
      let BL: marietta.core.Point;
      let TR: marietta.core.Point;
      let BR: marietta.core.Point;
      let r: number;
      let xx: number;
      let yy: number;
      let p1: marietta.core.Point;
      const groupRect:marietta.core.Rectangle = new marietta.core.Rectangle();
      for (i = 0; i < this.myItemList.length; i += 1) {
        // お部屋か階段であれば
        if ((this.myItemList[i] instanceof marietta.webcad.item.Stair) || (this.myItemList[i] instanceof marietta.webcad.item.Room)) {
          this.hasGridSnapItem = true;
        }

        elementName = `groupDummyBox_rect${i}`;
        if (this.myItemList[i] instanceof marietta.webcad.item.Room) {
          rects = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          rects.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString((this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.dotList));
          rects.setAttribute('transform', (this.myItemList[i] as marietta.webcad.item.Room).viewObj.getAttribute('transform'));
        } else {
          if ((this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.id.indexOf('fit') > -1) this.hasGridSnapItem = true;
          bound = ((this.myItemList[i] as marietta.webcad.item.MonicaObject).viewObj).getBoundingClientRect();
          rects = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
          rects.setAttribute('width', String((bound.width * 1) / marietta.webcad.WebCADGlobal.scaleSize));
          rects.setAttribute('height', String((bound.height * 1) / marietta.webcad.WebCADGlobal.scaleSize));

          r = (((this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.rotation % 360) / 180) * Math.PI;
          const bbox = ((this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.element as any).getBBox();

          // 各4頂点の座標の回転角度を考慮した座標を求め、minX,minYを求める
          p1 = new marietta.core.Point(bbox.x * (this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.scaleX, bbox.y * (this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.scaleY);
          xx = p1.x * Math.cos(r) - p1.y * Math.sin(r);
          yy = p1.x * Math.sin(r) + p1.y * Math.cos(r);
          TL = new marietta.core.Point(xx, yy);

          p1 = new marietta.core.Point(bbox.x * (this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.scaleX, (bbox.y + bbox.height) * (this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.scaleY);
          xx = p1.x * Math.cos(r) - p1.y * Math.sin(r);
          yy = p1.x * Math.sin(r) + p1.y * Math.cos(r);
          BL = new marietta.core.Point(xx, yy);

          p1 = new marietta.core.Point((bbox.x + bbox.width) * (this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.scaleX, bbox.y * (this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.scaleY);
          xx = p1.x * Math.cos(r) - p1.y * Math.sin(r);
          yy = p1.x * Math.sin(r) + p1.y * Math.cos(r);
          TR = new marietta.core.Point(xx, yy);

          p1 = new marietta.core.Point((bbox.x + bbox.width) * (this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.scaleX, (bbox.y + bbox.height) * (this.myItemList[i] as marietta.webcad.item.MonicaObject).spt.scaleY);
          xx = p1.x * Math.cos(r) - p1.y * Math.sin(r);
          yy = p1.x * Math.sin(r) + p1.y * Math.cos(r);
          BR = new marietta.core.Point(xx, yy);

          xx = Math.min(Math.min(TL.x, BL.x), Math.min(TR.x, BR.x));
          yy = Math.min(Math.min(TL.y, BL.y), Math.min(TR.y, BR.y));

          rects.setAttribute('x', String((this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.x + xx));
          rects.setAttribute('y', String((this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.y + yy));

          // グループアイテムboundBox計算
          const groupBound:marietta.core.Rectangle = new marietta.core.Rectangle();
          groupBound.x = (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.x + xx;
          groupBound.y = (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.y + yy;
          groupBound.width = (bound.width / marietta.webcad.WebCADGlobal.scaleSize);
          groupBound.height = (bound.height / marietta.webcad.WebCADGlobal.scaleSize);
          if (i === 0) {
            groupRect.x = groupBound.x;
            groupRect.y = groupBound.y;
            groupRect.width = groupBound.width;
            groupRect.height = groupBound.height;
          } else {
            if (groupBound.x < groupRect.x) {
              groupRect.x = groupBound.x;
            }
            if (groupBound.y < groupRect.y) {
              groupRect.y = groupBound.y;
            }
            if (groupRect.width < (groupBound.x + groupBound.width)) {
              groupRect.width = groupBound.x + groupBound.width;
            }
            if (groupRect.height < (groupBound.y + groupBound.height)) {
              groupRect.height = groupBound.y + groupBound.height;
            }
          }
        }

        rects.setAttribute('fill', '#3598DC');
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE || marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE) {
          rects.setAttribute('opacity', '0');
        } else {
          rects.setAttribute('opacity', '0.3');
        }

        rects.setAttribute('id', elementName);
        rects.setAttribute('data-index', String(i));

        // アクション
        if (ua.isMobile || ua.isTablet) {
          rects.addEventListener('touchstart', this.unselectTarget, { passive: false });
        } else {
          rects.addEventListener('mousedown', this.unselectTarget);
          if (this.myItemList[i] instanceof marietta.webcad.item.Site) {
            rects.addEventListener('mouseover', this.onMouseOverMe);
          }
        }
        this.spt.element.appendChild(rects);
        // 要素名の保管
        this.shapeList.push(elementName);
      }

      // ダミーグループアイテムboundingBox長方形を作成します
      // アイテムメニューからグループアイテムを作成する場合にのみ使用されます
      // アイテムグループの選択を維持するために使用されます。ダミーgroupRectはlayerGroupクリックを防ぎます
      groupRect.width -= groupRect.x;
      groupRect.height -= groupRect.y;
      if (marietta.WebCADGlobal.itemMenu.itemMenuCreateFlag) {
        const dummyBox = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        dummyBox.setAttribute('id', 'groupDummyBox_area');
        dummyBox.setAttribute('width', String(groupRect.width));
        dummyBox.setAttribute('height', String(groupRect.height));
        dummyBox.setAttribute('x', String(groupRect.x));
        dummyBox.setAttribute('y', String(groupRect.y));
        dummyBox.setAttribute('fill', '#3598DC');
        dummyBox.setAttribute('opacity', '0');
        this.spt.element.appendChild(dummyBox);
      }
      this.spt.mouseEnabled = true;
      ua = null;
    }

    /**
     * viewObjの返却
     */
    get viewObj(): Element {
      return this.spt.element;
    }

    /**
     * 初期化
     */
    initMe = () => {
      // 基本アクション
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        this.spt.element.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        this.spt.element.addEventListener('mousedown', this.onMouseDownMe);
      }
      ua = null;
    }

    /**
     * アイテムの選択解除
     */
    unselectTarget = (e: MouseEvent&TouchEvent) => {
      // 2本指ジェスチャ（ピンチ・パン）の指がたまたま選択中アイテムに触れただけの場合は無視する。
      // これが無いと、2本指操作で指が乗った選択済みアイテムが次々にトグルオフされてしまう。
      if (e.touches && e.touches.length > 1) return;
      // ドラッグ開始であれば無視
      // タブレット等の複数選択モードでは、キー修飾なしのタップでも選択解除（トグルオフ）できるようにする
      if (!e.ctrlKey && !e.shiftKey && !marietta.webcad.WebCADGlobal.webcad2Dmanager.isTapMultiSelectMode) return;

      const targetElement:SVGElement = (<SVGElement>e.target);
      const targetIndex: number = parseInt(targetElement.getAttribute('data-index'), 10);
      const target = this.myItemList[targetIndex];

      // タップ多重選択モード中、部屋のハイライトは部屋の全形状を覆うため、部屋内にある家具等をタップしても
      // このハイライトがイベントを受け取ってしまう。実際にタップされたのが部屋の空き床ではなくアイテムの場合は、
      // 部屋を解除せずそのアイテムの選択（グループへの追加／トグル解除）を優先する。
      // ※ 部屋自身の再取得（部屋の空き床タップ）は従来どおりの解除動作に倒すため、
      //   参照の同一性ではなく「部屋以外のアイテムか」で判定する。
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isTapMultiSelectMode && target instanceof marietta.webcad.item.Room) {
        const realItem: marietta.webcad.item.MonicaObject = this.findRealItemUnderPoint(e);
        if (realItem && !(realItem instanceof marietta.webcad.item.Room)) {
          marietta.webcad.WebCADGlobal.itemManager.addItemToGroupObject(realItem);
          return;
        }
      }

      // 選択の解除
      this.unselectItem(target);
    }

    /**
     * タップ座標の周辺を探索する際の許容半径（px）。
     * ピン等、塗り面積が小さいアイコンはタップ座標そのものではヒットしないことがあるため、
     * 中心とその周囲8方向を探索してタップの取りこぼしを吸収する。
     */
    private static readonly TAP_PROBE_TOLERANCE_PX: number = 8;

    /**
     * タップ座標を中心とした周囲8方向＋中心（計9点）の探索オフセット一覧。
     */
    private static readonly TAP_PROBE_OFFSETS: ReadonlyArray<[number, number]> = [
      [0, 0],
      [-GroupItem.TAP_PROBE_TOLERANCE_PX, 0], [GroupItem.TAP_PROBE_TOLERANCE_PX, 0],
      [0, -GroupItem.TAP_PROBE_TOLERANCE_PX], [0, GroupItem.TAP_PROBE_TOLERANCE_PX],
      [-GroupItem.TAP_PROBE_TOLERANCE_PX, -GroupItem.TAP_PROBE_TOLERANCE_PX], [GroupItem.TAP_PROBE_TOLERANCE_PX, -GroupItem.TAP_PROBE_TOLERANCE_PX],
      [-GroupItem.TAP_PROBE_TOLERANCE_PX, GroupItem.TAP_PROBE_TOLERANCE_PX], [GroupItem.TAP_PROBE_TOLERANCE_PX, GroupItem.TAP_PROBE_TOLERANCE_PX],
    ];

    /**
     * タップ座標にある実アイテムを取得します。
     * 部屋の選択ハイライトが家具・ピン等より前面に描画されているため、通常のヒットテストでは
     * ハイライトの背後にあるアイテムを直接取得できません。座標上の全要素を取得し、
     * 自分自身のハイライト要素・部屋自身を除いた最前面のアイテムを探します。
     * ピンのように塗り面積が小さいアイコンはタップ座標そのものでは取りこぼすことがあるため、
     * 中心がヒットしなかった場合は周辺も探索します。
     */
    private findRealItemUnderPoint(e: MouseEvent&TouchEvent): marietta.webcad.item.MonicaObject {
      const point: MouseEvent|Touch = (e.touches && e.touches.length > 0) ? e.touches[0] : e;
      const floorLayer: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) as marietta.webcad.layer.FloorLayer;
      const allItems: marietta.webcad.item.MonicaObject[] = floorLayer.getAllItems();

      for (const [offsetX, offsetY] of GroupItem.TAP_PROBE_OFFSETS) {
        const elementsAtPoint: Element[] = document.elementsFromPoint(point.clientX + offsetX, point.clientY + offsetY);
        for (const element of elementsAtPoint) {
          // 自分自身（部屋のハイライト）はスキップし、その背後にある要素を見る
          if (this.spt.element.contains(element)) continue;
          const hitItem: marietta.webcad.item.MonicaObject = allItems.find((item) => item.spt && item.spt.element && item.spt.element.contains(element));
          // 部屋自身・部屋名テキストは対象外（部屋の解除動作にフォールバックさせるため）
          if (hitItem && !(hitItem instanceof marietta.webcad.item.Room) && !(hitItem instanceof marietta.webcad.item.parts.RoomText)) return hitItem;
        }
      }
      return null;
    }

    /**
     * マウスダウンされた
     * @param MouseEvent
     */
    onMouseDownMe = (e: MouseEvent&TouchEvent) => {
      // アイテム作成後にフラグ値をリセットします
      marietta.WebCADGlobal.itemMenu.itemMenuCreateFlag = false;
      // ダミーグループ要素を削除します
      if (document.querySelector('#groupDummyBox_area')) {
        document.querySelector('#groupDummyBox_area').remove();
      }
      // ドラッグ中であれば、無視
      if (this.isFollowingMouse) {
        return;
      }

      // ドラッグ不可であれば無視
      if (!this.isCapableOfMove()) {
        return;
      }

      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (this.myItemList[0] instanceof marietta.webcad.item.Site && !marietta.webcad.WebCADGlobal.layerGroup.siteEnabled) {
        return;
      }
      // 選択モードのときは、バブリングさせない
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
        e.stopPropagation();

        if (!ua.isPC) e.preventDefault();
      }

      // まだ選択中であれば、無視
      // タブレット等の複数選択モードでは、キー修飾なしのタップでも個別のトグル選択を優先する
      if ((e.ctrlKey || e.shiftKey || marietta.webcad.WebCADGlobal.webcad2Dmanager.isTapMultiSelectMode) && (e !== null && e !== undefined)) return;

      // pad スマホ用タッチ座標修正
      if (ua.isMobile || ua.isTablet) {
        Stage.refreshStageMouse(<any>e);
      }

      this.previousPlace = new marietta.core.Point(this.spt.x, this.spt.y);

      const rect = this.spt.getBoundingClientRect();

      this.dragInitX = this.spt.mouseX * this.spt.scaleX;
      this.dragInitY = this.spt.mouseY * this.spt.scaleY;

      // 前回の位置の保持
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).saveCurrentPosition();

        // お部屋が選択中であれば、部屋テキストを隠す
        if (this.myItemList[i] instanceof marietta.webcad.item.Room) {
          (this.myItemList[i] as marietta.webcad.item.Room).hideChildren();
        }
        // 建具が選択中であれば、建具テキストを隠す
        if (this.myItemList[i] instanceof marietta.webcad.item.Fitting) {
          (this.myItemList[i] as marietta.webcad.item.Fitting).hideChildren();
        }
      }

      // ドラッグの開始
      if (ua.isMobile || ua.isTablet) {
        this.localDragPoint = new marietta.core.Point(e.pageX - rect.left, e.pageY - rect.top);
        document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
        document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
      } else {
        this.localDragPoint = new marietta.core.Point(e.clientX - rect.left, e.clientY - rect.top);
        document.addEventListener('mousemove', this.onMouseMoveMe);
        document.addEventListener('mouseup', this.onMouseUpMe);
      }

      const scope: GroupItem = this;

      // comment k.kubonaka
      // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
      // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
      this.spt.onEnterFrame = (): void => {
        if (scope.moveMouseEvent != null) {
          scope.mouseMoveHandler();
        }
      };
      ua = null;
    }

    private mouseMoveHandler(): void {
      // 移動XY
      let moveX: number = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX;
      let moveY: number = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY;

      if (this.hasGridSnapItem) {
        moveX = Math.round(moveX / marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix) * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
        moveY = Math.round(moveY / marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix) * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      }

      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.x = (this.myItemList[i] as marietta.webcad.item.MonicaObject).previousPlace.x + moveX;
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.y = (this.myItemList[i] as marietta.webcad.item.MonicaObject).previousPlace.y + moveY;
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).updateTransforms();
      }

      this.spt.x = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX;
      this.spt.y = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY;
      if (this.hasGridSnapItem) {
        this.spt.x = Math.round((marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX) / marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix) * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
        this.spt.y = Math.round((marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY) / marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix) * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      }

      this.spt.update();
    }

    /**
     * マウスが移動した
     */
    onMouseMoveMe = (e: MouseEvent&TouchEvent) => {
      // pad スマホ用タッチ座標修正
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        e.preventDefault();
        Stage.refreshStageMouse(<any>e);
      }

      this.moveMouseEvent = e;
      // GroupItemMoveの開始時に測定線を非表示にする
      if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.hasLineMeasurementItem()) {
        marietta.webcad.WebCADGlobal.itemManager.hideMeasureLine();
      }
    }

    /**
     * マウスがUPされた
     */
    onMouseUpMe = (e: MouseEvent&TouchEvent) => {
      e.preventDefault();
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchmove', this.onMouseMoveMe);
        document.removeEventListener('touchend', this.onMouseUpMe);
      } else {
        document.removeEventListener('mousemove', this.onMouseMoveMe);
        document.removeEventListener('mouseup', this.onMouseUpMe);
      }
      this.spt.deleteEnterFrame();
      this.moveMouseEvent = null;
      ua = null;

      // 部屋名の移動
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        // お部屋が選択中であれば、部屋テキストも移動
        if (this.myItemList[i] instanceof marietta.webcad.item.Room) {
          (this.myItemList[i] as marietta.webcad.item.Room).moveChildren();
          (this.myItemList[i] as marietta.webcad.item.Room).showChildren();
        }

        // 建具が選択中であれば、建具テキストを隠す
        if (this.myItemList[i] instanceof marietta.webcad.item.Fitting) {
          (this.myItemList[i] as marietta.webcad.item.Fitting).moveChildren();
          (this.myItemList[i] as marietta.webcad.item.Fitting).showChildren();
        }
        if (this.myItemList[i] instanceof marietta.webcad.item.Site) {
          (this.myItemList[i] as marietta.webcad.item.Site).showChildren();
          marietta.webcad.WebCADGlobal.itemControlPanel.setInfo();
        }
      }

      // 再描画
      this.createImage();
      if (this.myItemList[0] instanceof marietta.webcad.item.Site) {
        this.spt.mouseEnabled = false;
      }
      marietta.webcad.WebCADGlobal.itemManager.onItemsMoved();
      // 保管
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

      // ライン測定を更新する
      if (marietta.core.Point.distance(new marietta.core.Point(marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.spt.mouseX, marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.spt.mouseY), new marietta.core.Point(marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.dragInitX, marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.dragInitY)) !== 0) {
        marietta.webcad.WebCADGlobal.updateMeasureLine(false);
        marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
      }
    }

    onMouseOverMe = () => {
      if (this.myItemList[0] instanceof marietta.webcad.item.Site) {
        this.spt.mouseEnabled = false;
      }
    }

    /**
     * アイテムの追加
     * */
    selectItem(target: marietta.webcad.item.MonicaObject): void {
      // 部屋テキストは無視する
      if (target instanceof marietta.webcad.item.parts.RoomText) return;

      if (this.isWithinList(target)) {
        // 既に入っている場合は逆に選択を解除します。
        this.unselectItem(target);
      } else {
        this.myItemList.push(target);
      }

      // 表示の更新
      this.createImage();

      // メニューの状態を更新
      marietta.webcad.WebCADGlobal.itemControlPanel.setInfo();
    }

    /**
     * アイテムの削除
     * */
    unselectItem(target: marietta.webcad.item.MonicaObject): void {
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        if (target === this.myItemList[i]) {
          this.myItemList.splice(i, 1);
          break;
        }
      }
      // 全て解除された場合のみグループごと解除します。1件残った場合は、範囲選択で1件だけ選択された場合と同じ見た目（グループのまま）にします。
      if (this.myItemList.length === 0) {
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
      } else {
        this.createImage();
      }

      // メニューの状態を更新
      marietta.webcad.WebCADGlobal.itemControlPanel.setInfo();
    }

    /**
     * 自分自身の削除
     * */
    public static deleteMe(): void {
      if (document.querySelector('#groupDummyBox')) {
        document.querySelector('#groupDummyBox').remove();
      }
    }

    /**
     * 選択中のアイテムの選択
     */
    deleteSelectedItems(): void {
      for (let i: number = this.myItemList.length - 1; i >= 0; i -= 1) {
        if (this.myItemList[i].isCapableOfDelete()) (this.myItemList[i] as marietta.webcad.item.MonicaObject).deleteMe( null, true );
      }
      //見積情報の更新
      marietta.webcad.WebCADGlobal.quotationItemList.createData();

      // ライン測定を更新する
      marietta.webcad.WebCADGlobal.updateMeasureLine(false);
      // グループ削除
      marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

      // 保管
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * アイテムがグループの中に含まれている場合、trueを返します。
     * */
    isWithinList(target: marietta.webcad.item.MonicaObject): boolean {
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        if (target === this.myItemList[i]) {
          return true;
        }
      }
      return false;
    }

    /**
     * 回転
     */
    rotate(value: number): void {
      let _value = value;
      let tarItem;
      let rotateGenten: marietta.core.Point;
      // let boundRect;
      let bound: marietta.core.Rectangle;
      let allBound: marietta.core.Rectangle;
      let rotateOnGrid: boolean = false;
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        tarItem = this.myItemList[i];
        if (tarItem instanceof marietta.webcad.item.Room || tarItem instanceof marietta.webcad.item.Stair || tarItem instanceof marietta.webcad.item.Fitting || tarItem instanceof marietta.webcad.item.WallObject || tarItem instanceof marietta.webcad.item.Beam || tarItem instanceof marietta.webcad.item.Column ) rotateOnGrid = true;

        // お部屋の場合は、Rect情報の算出方法を変更する
        bound = (tarItem as marietta.webcad.item.MonicaObject).getBoundRect();

        if (!allBound) {
          allBound = bound.clone();
        } else {
          allBound = allBound.union(bound);
        }
      }
      if (rotateOnGrid) {
        // 回転角度
        if (_value < 0) {
          _value = -90;
        } else {
          _value = 90;
        }

        rotateGenten = new marietta.core.Point(Math.round((allBound.x + allBound.width / 2) / 60) * 60, Math.round((allBound.y + allBound.height / 2) / 60) * 60);
      } else {
        rotateGenten = new marietta.core.Point(allBound.x + allBound.width / 2, allBound.y + allBound.height / 2);
      }

      // 部屋の頂点情報の回転
      for (let i = 0; i < this.myItemList.length; i += 1) {
        tarItem = this.myItemList[i];
        if ((tarItem instanceof marietta.webcad.item.Room)) {
          (tarItem as marietta.webcad.item.Room).rotateDots(_value);
          (tarItem as marietta.webcad.item.Room).reCreateImage();

          // (tarItem as marietta.webcad.item.MonicaObject).snapToGrid();
        } else if ((tarItem instanceof marietta.webcad.item.WallObject)) {
          (tarItem as marietta.webcad.item.WallObject).rotateDots(_value);
          (tarItem as marietta.webcad.item.WallObject).reCreateImage();
        } else if ((tarItem instanceof marietta.webcad.item.Beam)) {
          (tarItem as marietta.webcad.item.Beam).rotateDots(_value);
          (tarItem as marietta.webcad.item.Beam).reCreateImage();
        } else if ((tarItem instanceof marietta.webcad.item.Column)) {
          (tarItem as marietta.webcad.item.Column).rotateDots(_value);
          (tarItem as marietta.webcad.item.Column).reCreateImage();
        }
      }

      const theta: number = (_value * Math.PI) / 180;
      const nSin: number = Math.sin(theta);
      const nCos: number = Math.cos(theta);
      let nX: number;
      let nY: number;
      let tarText;
      for (let i = 0; i < this.myItemList.length; i += 1) {
        tarItem = this.myItemList[i];
        nX = tarItem.itemInfo.x - rotateGenten.x;
        nY = tarItem.itemInfo.y - rotateGenten.y;
        tarItem.itemInfo.x = rotateGenten.x + nCos * nX - nSin * nY;
        tarItem.itemInfo.y = rotateGenten.y + nSin * nX + nCos * nY;
        if (tarItem instanceof marietta.webcad.item.Room) {
          tarText = (tarItem as marietta.webcad.item.Room).overlayText;
          (tarText as marietta.webcad.item.parts.RoomText).autoLayout = true;
        } else if (tarItem instanceof marietta.webcad.item.WallObject ||  tarItem instanceof marietta.webcad.item.Beam || tarItem instanceof marietta.webcad.item.Column) {
          //何もしない
        } else if (tarItem instanceof marietta.webcad.item.Site) {
          const points = [];
          for (let j = 0; j < tarItem.itemInfo.dotList.length; j += 1) {
            const rotatedX = Math.cos(theta) * (tarItem.itemInfo.dotList[j].x + tarItem.itemInfo.x - tarItem.itemInfo.x) - Math.sin(theta) * (tarItem.itemInfo.dotList[j].y + tarItem.itemInfo.y - tarItem.itemInfo.y) + tarItem.itemInfo.x;
            const rotatedY = Math.sin(theta) * (tarItem.itemInfo.dotList[j].x + tarItem.itemInfo.x - tarItem.itemInfo.x) + Math.cos(theta) * (tarItem.itemInfo.dotList[j].y + tarItem.itemInfo.y - tarItem.itemInfo.y) + tarItem.itemInfo.y;
            points.push(new marietta.core.Point(rotatedX, rotatedY));
          }

          for (let k = 0; k < points.length; k += 1) {
            tarItem.itemInfo.dotList[k].point.x = points[k].x - tarItem.itemInfo.x;
            tarItem.itemInfo.dotList[k].point.y = points[k].y - tarItem.itemInfo.y;
            tarItem.itemInfo.dotList[k].x = points[k].x - tarItem.itemInfo.x;
            tarItem.itemInfo.dotList[k].y = points[k].y - tarItem.itemInfo.y;
          }
        } else {
          tarItem.itemInfo.rotation += _value;
          if (tarItem.itemInfo.rotation >= 360) tarItem.itemInfo.rotation %= 360;
          if (tarItem.itemInfo.rotation < 0) tarItem.itemInfo.rotation += 360;
        }

        if (tarItem instanceof marietta.webcad.item.Site) {
          (tarItem as marietta.webcad.item.Site).reCreateImage();
        } else {
          (tarItem as marietta.webcad.item.MonicaObject).updateTransforms();
        }

        // カメラピンのマトリクス更新
        if (marietta.webcad.WebCADGlobal.isPinPictureItem(tarItem.itemInfo.id)) {
          tarItem = this.updateCameraPin(tarItem, theta);
        }

      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE || marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_SITE) {
        (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1).layer_site as marietta.webcad.layer.SiteLayer).putLayerItemsInGroup();
        marietta.webcad.WebCADGlobal.itemControlPanel.setInfo();
      } else {
        // 更新
        this.createImage();
      }
    }
  }

    /**
     * カメラピンのマトリクス更新
     */
  updateCameraPin(tarItem: marietta.webcad.item.MonicaObject, theta: number): marietta.webcad.item.MonicaObject {
        if (marietta.webcad.WebCADGlobal.isPinPictureItem(tarItem.itemInfo.id)) {
          const elements = tarItem.itemInfo.transformMatrix;
          const xVec = new THREE.Vector3(elements[0], elements[1], elements[2]);
          xVec.applyAxisAngle(new THREE.Vector3(0, 1, 0), -theta);
          const yVec = new THREE.Vector3(elements[4], elements[5], elements[6]);
          yVec.applyAxisAngle(new THREE.Vector3(0, 1, 0), -theta);
          const zVec = new THREE.Vector3(elements[8], elements[9], elements[10]);
          zVec.applyAxisAngle(new THREE.Vector3(0, 1, 0), -theta);
          tarItem.itemInfo.transformMatrix = [
            xVec.x, xVec.y, xVec.z, elements[3],
            yVec.x, yVec.y, yVec.z, elements[7],
            zVec.x, zVec.y, zVec.z, elements[11],
            elements[12], elements[13], elements[14], elements[15]
          ];
        }
        return tarItem;
    }

    /**
     * 反転する
     */
    flip(): void {
      let tarItem;
      let flipGenten: marietta.core.Point;
      let bound: marietta.core.Rectangle;
      let allBound: marietta.core.Rectangle;
      let rotateOnGrid: boolean = false;
      // let tarText;

      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        tarItem = this.myItemList[i];
        // if (tarItem instanceof marietta.webcad.item.Room || tarItem instanceof marietta.webcad.item.Stair) rotateOnGrid = true;

        // お部屋の場合は、Rect情報の算出方法を変更する
        bound = (tarItem as marietta.webcad.item.MonicaObject).getBoundRect();

        if (!allBound) {
          allBound = bound.clone();
        } else {
          allBound = allBound.union(bound);
        }
      }

      if (rotateOnGrid) {
        flipGenten = new marietta.core.Point(Math.round((allBound.x + allBound.width / 2) / 60) * 60, Math.round((allBound.y + allBound.height / 2) / 60) * 60);
      } else {
        flipGenten = new marietta.core.Point(allBound.x + allBound.width / 2, allBound.y + allBound.height / 2);
      }

      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        tarItem = this.myItemList[i];
        // 部屋
        if (tarItem instanceof marietta.webcad.item.Room || tarItem instanceof marietta.webcad.item.WallObject ||  tarItem instanceof marietta.webcad.item.Beam || tarItem instanceof marietta.webcad.item.Column) {
          (tarItem).flipDots();
        } else if (marietta.webcad.WebCADGlobal.isPinPictureItem(tarItem.itemInfo.id)) {
          // カメラピン
          let deg = 360 - (tarItem as marietta.webcad.item.MonicaObject).itemInfo.rotation;
          (tarItem as marietta.webcad.item.MonicaObject).rotate(deg);
          const radiun = Math.abs(deg * 2) * (Math.PI / 180); // 3Dでの回転角に直して、ラジアンを計算する
          tarItem = this.updateCameraPin(tarItem, radiun);
        } else {
          // その他アイテム
          (tarItem as marietta.webcad.item.MonicaObject).rotate(360 - (tarItem as marietta.webcad.item.MonicaObject).spt.rotation);
          (tarItem as marietta.webcad.item.MonicaObject).reverse();
        }
        (tarItem as marietta.webcad.item.MonicaObject).moveX(flipGenten.x - ((tarItem as marietta.webcad.item.MonicaObject).itemInfo.x - flipGenten.x));
      }

      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        tarItem = this.myItemList[i];
        if (tarItem instanceof marietta.webcad.item.Room) {
          (tarItem as marietta.webcad.item.Room).overlayText.resetRoomNamePosition();
        }
      }

      // 更新
      this.createImage();
    }

    // ----------------------------Follow Mouse--------------------------
    /**
     * マウス追従開始
     */
    startFollowMouse = () => {
      // 移動XY
      const moveX: number = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX;
      const moveY: number = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY;

      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).previousPlace = new marietta.core.Point((this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.x, (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.y);
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.x = (this.myItemList[i] as marietta.webcad.item.MonicaObject).previousPlace.x + moveX;
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.y = (this.myItemList[i] as marietta.webcad.item.MonicaObject).previousPlace.y + moveY;
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).updateTransforms();

        // 子供を隠す
      }
      if (marietta.webcad.WebCADGlobal.itemMenu._tempHideMenu !== '')marietta.webcad.WebCADGlobal.itemMenu.hideAll();
      this.isFollowingMouse = true;

      this.dragInitX = this.spt.mouseX * this.spt.scaleX;
      this.dragInitY = this.spt.mouseY * this.spt.scaleY;

      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.addEventListener('touchmove', this.followMouse, { passive: false });
        document.addEventListener('touchend', this.stopFollowMouse, { passive: false });
      } else {
        document.addEventListener('mousemove', this.followMouse);
        document.addEventListener('mousedown', this.stopFollowMouse);
      }

      // comment k.kubonaka
      // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
      // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
      const scope = this;
      this.spt.onEnterFrame = (): void => {
        if (scope.moveMouseEvent != null) {
          scope.followMouseHandler();
        }
      };
      marietta.webcad.WebCADGlobal.itemControlPanel.disableFooterControlButtons();
    }

    private followMouseHandler() {
      // 移動XY
      let moveX: number = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX;
      let moveY: number = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY;

      if (this.hasGridSnapItem) {
        moveX = Math.round(moveX / marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix) * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
        moveY = Math.round(moveY / marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix) * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      }

      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.x = (this.myItemList[i] as marietta.webcad.item.MonicaObject).previousPlace.x + moveX;
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.y = (this.myItemList[i] as marietta.webcad.item.MonicaObject).previousPlace.y + moveY;
        (this.myItemList[i] as marietta.webcad.item.MonicaObject).updateTransforms();
      }

      this.spt.x = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX;
      this.spt.y = marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY;
      if (this.hasGridSnapItem) {
        this.spt.x = Math.round((marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.dragInitX) / marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix) * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
        this.spt.y = Math.round((marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.dragInitY) / marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix) * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      }

      this.spt.update();
    }

    /**
     * マウス追従
     */
    followMouse = (e: MouseEvent) => {
      e.preventDefault();
      this.moveMouseEvent = e;
    }

    /**
     * マウス追従終了
     */
    stopFollowMouse = (e: Event = null) => {
      // ボタンが押されていたら無視
      if (e != null) {
        let { target } = e;
        while ((target as any).parentNode) {
          target = (target as any).parentNode;
          if (String((target as any).nodeName) === 'BUTTON') {
            return;
          }
        }

        e.preventDefault();
      }

      this.isFollowingMouse = false;
      this.spt.deleteEnterFrame();

      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchmove', this.followMouse);
        document.removeEventListener('touchend', this.stopFollowMouse);
      } else {
        document.removeEventListener('mousemove', this.followMouse);
        document.removeEventListener('mousedown', this.stopFollowMouse);
      }
      ua = null;

      marietta.webcad.WebCADGlobal.itemControlPanel.panelUpdate();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      this.createImage();
      if (marietta.webcad.WebCADGlobal.itemMenu._tempHideMenu !== '')marietta.webcad.WebCADGlobal.itemMenu.show(marietta.webcad.WebCADGlobal.itemMenu._tempHideMenu);
    }

    /**
     * 移動
     */
    move(x: number, y: number) {
      // 移動XY
      const moveX: number = x;
      const moveY: number = y;
      this.spt.x = moveX;
      this.spt.y = moveY;
      const self = this;

      for (let i: number = 0; i < self.myItemList.length; i += 1) {
        (self.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.x = (self.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.x + moveX;
        (self.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.y = (self.myItemList[i] as marietta.webcad.item.MonicaObject).itemInfo.y + moveY;
        (self.myItemList[i] as marietta.webcad.item.MonicaObject).updateTransforms();
      }

      this.spt.update();

      let childX: number;
      let childY: number;
      // 部屋名の移動
      for (let j: number = 0; j < self.myItemList.length; j += 1) {
        // お部屋が選択中であれば、部屋テキストも移動
        if ((self.myItemList[j] instanceof marietta.webcad.item.Room)) {
          childX = (self.myItemList[j] as marietta.webcad.item.Room).overlayText.x + x;
          childY = (self.myItemList[j] as marietta.webcad.item.Room).overlayText.y + y;
          (self.myItemList[j] as marietta.webcad.item.Room).overlayText.move(childX, childY);
        }
      }

      // 再描画
      this.createImage();
    }

    /**
     * 建具種類の変更
     */
    public changeType(id: string): void {
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        if (!(this.myItemList[i] instanceof marietta.webcad.item.MonicaObject)) {
          (this.myItemList[i] as marietta.webcad.item.MonicaObject).changeType(id);
        }
      }
    }

    /**
     * 移動可能か
     */
    public isCapableOfMove(): boolean {
      if (this.myItemList.find((item) => !item.isCapableOfMove())) return false;
      return true;
    }

    /**
     * 削除可能か
     */
    public isCapableOfDelete(): boolean {
      if (this.myItemList.find((item) => !item.isCapableOfDelete())) return false;
      return true;
    }

    /**
     * 削除可能か
     */
    public isCapableOfSwitch(): boolean {
      if (this.myItemList.find((item) => !item.isCapableOfSwitch())) return false;
      return true;
    }

    /**
     * 回転可能か
     */
    public isCapableOfRotate(): boolean {
      if (this.myItemList.find((item) => !item.isCapableOfRotate())) return false;
      return true;
    }

    /**
     * 反転も可能か
     */
    public isCapableOfReverse(): boolean {
      if (this.myItemList.find((item) => !item.isCapableOfReverse())) return false;
      return true;
    }

    /**
     * Room Join
     * @returns
     */
    public isCapableOfRoomJoin(): boolean {
      if (this.myItemList.filter((item) => !item.itemInfo.lock && item instanceof marietta.webcad.item.Room).length !== 2) return false;
      return true;
    }

    /**
     * update text attributes
     */
    public updateTranslate(): void {
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        if (this.myItemList[i] instanceof marietta.webcad.item.Site) {
          for (let j: number = 0; j < (this.myItemList[i] as marietta.webcad.item.Site).lines.length; j += 1) {
            ((this.myItemList[i] as marietta.webcad.item.Site).lines[j].partnerText as marietta.webcad.item.parts.SiteText).updateTranslate();
          }
          ((this.myItemList[i] as marietta.webcad.item.Site).altitudelineText as marietta.webcad.item.parts.SiteAltitudeLineText).updateTranslate();
        }
      }
    }

    /**
     * それは整列することができますか
     * グループアイテムでのチェックは調整可能です。 GroupItemにEquipmentItemとFurnitureItemのみが含まれる場合、位置合わせが可能です。
     * @return boolean
     */
    public isCapableOfAlign(): boolean {
      let isValid = false;
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        const targetId = this.myItemList[i].itemInfo.id;
        const targetKey = targetId.substring(0, 3);
        if (targetKey === ITEM_MODE_KEY.MODE_FURNITURE_KEY || targetKey === ITEM_MODE_KEY.MODE_EQUIPMENT_KEY || targetKey === ITEM_MODE_KEY.MODE_EXTERIOR_KEY) {
          isValid = true;
        } else {
          isValid = false;
          return isValid;
        }
      }
      return isValid;
    }

    /**
     * groupItemに行測定項目があることを確認します
     * @return boolean
    */
    public hasLineMeasurementItem(): boolean {
      let isValid = false;
      for (let i: number = 0; i < this.myItemList.length; i += 1) {
        const targetId = this.myItemList[i].itemInfo.id;
        const targetKey = targetId.substring(0, 3);
        if (targetKey === ITEM_MODE_KEY.MODE_ROOM_KEY || targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
          isValid = true;
          return isValid;
        }
        isValid = false;
      }
      return isValid;
    }
}
